export const domainDetails = {
    fancode: {
        logo: '/img/867f5c067d544a3f79567a893209f1c4 (1).svg',
        id: '630e193b397f3f66d5c7a6d5',
        name: 'Fancode'
    },
    cureayu: {
        logo: '/img/cureayu.png',
        id: '65c1cd8117be30519ff55096',
        name: 'Cureayu'
    },
    neemans: {
        logo: '/img/neemans.svg',
        id: '6634c8ad2fd1cb4630e9d1e8',
        name: 'Neemans',
        webUrl: 'https://neemans.com/',
        banner: {
            large: '/img/neemans_desktop.jpg',
            small: '/img/neemans_mobile.jpg'
        }
    },
    atovio: {
        logo: '/img/atoviofooter.jpg',
        id: '67470509d56298539d20d8f7',
        name: 'Atovio',
        webUrl: 'https://atovio.in/',
        banner: {
            large: '/img/atovio_header.jpg',
            small: '/img/atovio_header.jpg'
        }
    },
    default: {
        logo: '/img/prozo.png'
    },
    // 'localhost:3000': {
    //     logo: '/img/atovio.png',
    //     id: '6634c8ad2fd1cb4630e9d1e8',
    //     name: 'Neemans',
    //     webUrl: 'https://atovio.com/',
    //     banner: {
    //         large: '/img/atovio_header.jpg',
    //         small: '/img/atovio_header.jpg'
    //     }
    // },
    comet: {
        logo: '/img/comet.png',
        id: '649c23adca521f1d45138702',
        name: 'Comet'
    },
    sg: {
        logo: '/img/sg.png',
        id: '62eba5701a6b3a0ad61ead99',
        name: 'SG'
    },
    tcpl: {
        logo: '/img/tcpl.png',
        id: '630e1e95397f3f66d5c7a79b',
        name: 'TCPL'
    },
    maapooja: {
        logo: '/img/maapooja.png',
        id: '6814a1d2ecd5fc2c7d8b5d36',
        name: 'Maapooja'
    },
    baidyanathayurved: {
        logo: '/img/baidyanathayurved.png',
        id: '669e35c34731fe7eb440a029',
        name: 'Baidyanath'
    },
    trusoul: {
        logo: '/img/trusoul.png',
        id: '66c47d5880b1e00948490629',
        name: 'Trusoul'
    },
    kayascience: {
        logo: '/img/kaya1.png',
        id: '66cec9ced191cf4d9129b9fd',
        name: 'Kaya'
    },
    oziss: {
        logo: '/img/oziss.png',
        id: '6698fa7a24f7124e4e33e05d',
        name: 'Oziss'
    },
    arihantpublications: {
        logo: '/img/arihantpublications.png',
        id: '653a064929a52f4b06fff2f2',
        name: 'Arihant Publications'
    },
    labelaarna: {
        logo: '/img/labelaarna.png',
        id: '673c92ec6496502aeed29c75',
        name: 'Label Aarna'
    },
    powerguard: {
        logo: '/img/powerguard.png',
        id: '6745a99242caba2f51a89ce2',
        name: 'Power Guard'
    },
    silvish: {
        logo: '/img/silvish.png',
        id: '674b0ee06ecff14abacec9cc',
        name: 'Power Guard'
    },
    godsmode: {
        logo: '/img/godsmode.png',
        id: '675ad76cf8793c7592636b90',
        name: 'Gods Mode'
    },
    superdog: {
        logo: '/img/superdog.png',
        id: '67482a7ad56298539d237e5b',
        name: 'Superdog'
    },
    sparify: {
        logo: '/img/sparify.png',
        id: '676e9ebaa20b635337613afc',
        name: 'Sparify'
    },
    ferrago: {
        logo: '/img/ferrago.png',
        id: '6773d72222a9005e7976e461',
        name: 'Ferrago'
    },
    youthnic: {
        logo: '/img/youthnic.png',
        id: '679b81061cf6977e529c6f7a',
        name: 'Youthnic'
    },
    pairietales: {
        logo: '/img/pairietales.png',
        id: '67ea37e8a7208d75355e5959',
        webUrl: 'https://www.pairietales.com/',
        name: 'Pairie Tales',
        enableReturn: true
    },
    dsflex: {
        logo: '/img/dsflex.png',
        id: '683ed8be119023406e164d71',
        webUrl: 'https://www.dsflex.in/',
        name: 'DSFlex'
    },
    fausto: {
        logo: '/img/fausto.png',
        id: '6822fe40ef12be217ea4faf3',
        webUrl: 'https://www.fausto.in/',
        name: 'Fausto'
    },
    trunativ: {
        logo: '/img/trunativ.png',
        id: '6825895da0c9dc4e65db9e1d',
        webUrl: 'https://trunativ.co/',
        name: 'Trunativ'
    },
    zwende: {
        logo: '/img/zwende2.png',
        id: '67b438fe8579731d83072d3e',
        webUrl: 'https://www.zwende.com/',
        name: 'Zwende',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    cavaathleisure: {
        logo: '/img/cava.png',
        id: '68676c8b03406c1808331a21',
        webUrl: 'https://cavaathleisure.com/',
        name: 'Cava',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    allied: {
        logo: '/img/allied.png',
        id: '689acbeabf94cd6bec3bc33e',
        // webUrl: 'https://www.kokoon.com/',
        name: 'Allied Book Company',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    zeesh: {
        logo: '/img/zeesh.png',
        id: '68971a47bf94cd6bec2daa43',
        webUrl: 'https://www.zeesh.co.in/',
        name: 'Zeesh',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    dharasana: {
        logo: '/img/dharasana.png',
        id: '6868e452ca5ea80c7cc6aeff',
        webUrl: 'https://www.dharasana.in/',
        name: 'Dharasana',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    premiumjewellers: {
        logo: '/img/premiumjewellers.png',
        id: '687f5aac7066033e507f1ffe',
        // webUrl: 'https://www.dharasana.in/',
        name: 'Premium Jewellers',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    shopabs4u: {
        logo: '/img/shopabs4u.png',
        id: '68b28ab98a2be372eb30adf5',
        webUrl: 'https://shopabs4u.com/',
        name: 'SHOPABS4U',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    vayawear: {
        logo: '/img/vayawear.png',
        id: '68ca6f41867af64b1d00c19f',
        webUrl: 'https://vayawear.in/',
        name: 'Vaya Wear',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    auric: {
        logo: '/img/auric.png',
        id: '6909cdb9d70a0f43ca6e2d91',
        webUrl: 'www.theauric.com',
        name: 'Auric',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    lafoli: {
        logo: '/img/lafoli.png',
        id: '68ecf1ed56e57222a5418c8a',
        webUrl: 'https://wearlafoli.com/',
        name: 'Lafoli',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    gkpublications: {
        logo: '/img/gkpublications.png',
        id: '69047f342a72d6208664b4b3',
        webUrl: 'gkpublications.com',
        name: 'GK Publications',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    suniyara: {
        logo: '/img/suniyara.png',
        id: '68da29b3ae052e42d5520bfa',
        webUrl: 'https://www.houseofsuniyara.com/',
        name: 'House of Suniyara',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    tramora: {
        logo: '/img/tramora.png',
        id: '691da6c28608be29a793f19d',
        webUrl: 'https://tramora.co.in/',
        name: 'Tramora',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    kidstation: {
        logo: '/img/kidstation.png',
        id: '66e92f50aacf816dde2c9d70',
        webUrl: 'https://www.kidstation.in/',
        name: 'Autotronics',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    gearmilitary: {
        logo: '/img/gearmilitary.png',
        id: '694aad600c7ed8344243c7ab',
        webUrl: 'https://gearmilitary.com/',
        name: 'Gear Military',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    hummel: {
        logo: '/img/hummel.png',
        id: '674983decbcf757609b67f3e',
        webUrl: 'https://hummel.net.in/',
        name: 'Hummel',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    divisa: {
        logo: '/img/divisa.png',
        id: '6864c0700742ae5bd2d208a2',
        webUrl: 'https://divisastore.com/',
        name: 'Divisa',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    drortho: {
        logo: '/img/drorthoo.png',
        id: '68400eea119023406e19a4ff',
        webUrl: 'https://drorthooil.com/',
        name: 'Divisa',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    badman: {
        logo: '/img/badman.png',
        id: '6911c56b7442d23c4bc2469b',
        webUrl: 'https://badmangrooming.com/',
        name: 'Divisa',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    efflair: {
        logo: '/img/efflair.png',
        id: '692430456aa9996c926374ef',
        webUrl: 'https://efflair.com/',
        name: 'Efflair',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    ozuzu: {
        logo: '/img/ozuzu.png',
        id: '699d905ab7a6d30e0baef321',
        webUrl: 'www.ozuzu.com',
        name: 'Ozuzu',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    adda247: {
        logo: '/img/adda247.png',
        id: '646f26dbe94dd11da70b5924',
        webUrl: 'www.adda247.com',
        name: 'Adda247',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    hausandkinder: {
        logo: '/img/hausandkinder.png',
        id: '6a02fc010d74962fc3fc6025',
        webUrl: 'hausandkinder.com',
        name: 'Haus and Kinder',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    loomlooster: {
        logo: '/img/loomlooster.png',
        id: '6a0041061094f30958586994',
        webUrl: 'loomlooster.com',
        name: 'Loom & Looster',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    indewild: {
        logo: '/img/indewild2.png',
        id: '69c1063f69c1c00ddfd13c31',
        webUrl: 'https://india.indewild.com/',
        name: 'inde wild',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    mytrident: {
        logo: '/img/mytrident.png',
        id: '6a0fe7f9df9137698e2b2e16',
        webUrl: 'https://mytrident.com/',
        name: 'Trident',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    awshad: {
        logo: '/img/awshad.png',
        id: '6a2005cdc7fdf02a9174f806',
        webUrl: 'https://awshad.com',
        name: 'Awshad',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    suspire: {
        logo: '/img/suspire.png',
        id: '67bd697d261d905573322b28',
        webUrl: 'https://suspire.in',
        name: 'Suspire',
        style: {
            width: '150px',
            height: 'auto'
        }
    },
    nuvah: {
        logo: '/img/nuvah.png',
        id: '6a3bad95f756987581d334a4',
        webUrl: 'https://nuvah.in',
        name: 'Nuvah',
        enableReturn: true,
        style: {
            width: '150px',
            height: 'auto'
        },
        colors: {
            primary: {
                main: '#3C1F4C',
                light: '#E23D76',
            },
            success: {
                main: '#3C1F4C',
                light: '#7B5490',
            },
            background: {
                gradient: 'linear-gradient(180deg, #fdf8ff 0%, #f3eaf8 100%)',
            }
        }
    },
    upurfit: {
        logo: '/img/upurfit.png',
        id: '6a38fd923821b50bf1bc20e7',
        webUrl: 'https://upurfit.com/',
        name: 'UpUrFit',
        style: {
            width: '150px',
            height: '75px'
        }
    },
    nainitalsucculents: {
        logo: '/img/nainitalsucculents.png',
        id: '6a44b9c1830edf2540b6c4e2',
        webUrl: 'https://nainitalsucculents.com/',
        name: 'Nainital Succulents',
        style: {
            width: '150px',
            height: '75px'
        }
    },
    naiduhall: {
        logo: '/img/naiduhall.png',
        id: '6a06f8b0ad7ba545d0b37e95',
        webUrl: 'https://vnhnaiduhall.com/',
        name: 'Naidu Hall',
        style: {
            width: '150px',
            height: '75px'
        }
    },
    luxorcrayola: {
        logo: '/img/luxorcrayola.png',
        id: '6a27f250bd46f860b331d3eb',
        webUrl: 'https://luxorcrayola.com/',
        name: 'Luxor',
        style: {
            width: '150px',
            height: '75px'
        }
    },
    luxorparker: {
        logo: '/img/luxorparker.png',
        id: '6a27eef6bd46f860b331b223',
        webUrl: 'https://luxorparker.in/',
        name: 'Luxor',
        style: {
            width: '150px',
            height: '75px'
        }
    },
    greentechfashion: {
        logo: '/img/greentechfashion.png',
        id: '6a54a78ff2eefc3c71086ca4',
        webUrl: 'https://www.greentechfashion.in/',
        name: 'Greentech',
        style: {
            width: 'auto',
            height: '40px'
        },
        header: {
            bgcolor: '#000',
            color: '#fff',
            borderColor: 'transparent',
        },
        colors: {
            primary: {
                main: '#000',
                light: '#ff5733',
            },
            background: {
                gradient: 'linear-gradient(180deg, #fdf8ff 0%, #f3eaf8 100%)',
            }
        }
    },
    jaineed: {
        logo: '/img/Jainee.png',
        id: '6a8d5dffbbfbc0170e7145d5',
        webUrl: 'https://jaineed.com/',
        name: 'Jainee D.',
        style: {
            width: 'auto',
            height: '40px'
        },
        colors: {
            primary: {
                main: '#852842',
                light: '#F5EFE6',
            },
            background: {
                gradient: 'linear-gradient(180deg, #fdf8ff 0%, #f3eaf8 100%)',
            }
        }
    }
}